import * as React from "react";

import { faDesktop, faMoon, faSun } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";

import Selector from "~/ui/selectors/Selector";

const { useCallback } = React;

const themeOptions = [
	{
		value: "AUTO",
		label: "System default",
		icon: faDesktop,
	},
	{
		value: "LIGHT",
		label: "Light theme",
		icon: faSun,
	},
	{
		value: "DARK",
		label: "Dark theme",
		icon: faMoon,
	},
];

export default function ThemeSelector({ value, onChange }: { value: string; onChange: (value: string) => void }) {
	return (
		<Selector
			condensed
			value={themeOptions.find(option => option.value === value)}
			options={themeOptions}
			onChange={useCallback(({ value }) => onChange(value), [onChange])}
		/>
	);
}
